export default function viewOrEdit(to, next, settings) {
  const canEditModule = to.meta.permissions.can_edit

  if (canEditModule) {
    next({ ...settings })
  } else {
    next()
  }
}
